<template>
	<div v-if="isSigningTerms" class="fullscreen-overlay">
		<close-btn @click="cancelSigningTerms"/>
		<h2 class="overlay-header">Terms & Conditions</h2>

		<div class="overlay-body">
			<template v-if="!errorFetchingTerms">
				<div class="term-container">
<!--					<pdf-->
<!--						v-if="url"-->
<!--						:src="url"-->
<!--					/>-->

					<template v-if="url">
						<pdf
							v-for="i in numPages"
							:key="i"
							:src="src"
							:page="i"
						></pdf>
					</template>
					<div v-else>Loading PDF...</div>
<!--					<iframe-->
<!--						id="terms-iframe"-->
<!--						:src="url"-->
<!--						width="100%"-->
<!--						style="height: 100vh;">-->
<!--					</iframe>-->
				</div>

				<div class="signature-container">
					<div class="signature-title">
						<h4>Sign Here:</h4>

						<button
							class="better-mobile-btn grey"
							:disabled="isDrawing"
							@click="clear">
							clear
						</button>
					</div>

					<div>
						<VueSignaturePad
							width="100%"
							height="100px"
							style="border:2px solid black"
							ref="signaturePad"
							:options="{ onBegin, onEnd }"
						/>
					</div>
				</div>

				<div class="p-1">
					<button
						class="better-mobile-btn"
						:disabled="isDrawing || !isFormValid"
						@click="done">
						Submit
					</button>
				</div>
			</template>

			<template v-else>
				<p>There was an error getting the terms.</p>

				<div class="p-1">
					<p>Have the user sign a physical waiver:</p>
					<button
						class="better-mobile-btn"
						@click="signedPhysical">
						Signed Physical Waiver
					</button>
				</div>

				<div class="p-1">
					<p>Skip the waiver signing process:</p>
					<button
						class="better-mobile-btn"
						@click="skip">
						Skip
					</button>
				</div>
			</template>
		</div>

		<ErrorPopup
			:show="shouldShowError"
			:error-message="errorMessage"
			:btn-text="errorBtnText"
			@close="window.location.reload()"
		/>
	</div>
</template>

<script>
import CloseBtn from "@/components/CloseBtn.vue";
import { VueSignaturePad } from "vue-signature-pad";
import { isNonEmpty } from "../../public/fieldValidators.js";
import pdf from 'vue-pdf'
import ErrorPopup from "@/components/ErrorPopup.vue";

export default {
	components: {
		CloseBtn,
		VueSignaturePad,
		ErrorPopup,
		pdf,
	},
	props: {
		isSigningTerms: {
			type: Boolean,
			default: false
		},
		url: {
			type: String,
			default: ""
		},
		errorFetchingTerms: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			isDrawing: false,
			signedAt: null,
			signature: "",
			shouldShowError: false,
			errorMessage: "",
			errorBtnText: "",
			src: null,
			numPages: 0
		}
	},
	watch: {
		isSigningTerms(newValue) {
			if (newValue) {
				window.scrollTo({top: 0})
				this.signature = ""
				this.signedAt = null

				// Ensure the base64 string is prefixed correctly
				this.src = pdf.createLoadingTask(this.url)
				this.src.promise.then(pdfDoc => {
					this.numPages = pdfDoc.numPages
				})
			}
		}
	},
	computed: {
		isFormValid() {
			return isNonEmpty(this.signature) && isNonEmpty(this.signedAt)
		},
	},
	methods: {
		setNumPages(n) {
			console.log("here: " + n)
			this.numPages = n
		},
		onBegin() {
			this.isDrawing = true
		},
		onEnd() {
			if(!this.$refs.signaturePad || typeof this.$refs.signaturePad.saveSignature !== 'function') {
				this.showError()
			}

			this.isDrawing = false
			this.signedAt = new Date()
			const { data } = this.$refs.signaturePad.saveSignature()
			this.signature = data
		},
		clear() {
			if(!this.$refs.signaturePad || typeof this.$refs.signaturePad.clearSignature !== 'function') {
				this.showError()
			}

			this.$refs.signaturePad.clearSignature()
			this.signature = ""
			this.signedAt = null
		},
		done() {
			this.$emit('submit', {
				signature: this.signature,
				signedAt: this.signedAt,
			})
		},
		signedPhysical() {
			this.$emit('signedPhysical')
		},
		skip() {
			this.$emit('skipped')
		},
		cancelSigningTerms() {
			this.$emit('cancel')
		},
		showError(msg = 'Error, please refresh page', btnText = "Refresh") {
			this.shouldShowError = true
			this.errorMessage = msg
			this.errorBtnText = btnText
		},
	},
}
</script>

<style scoped>
.term-container {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: flex-start;
	width: 100vw;
	height: min-content;
	margin: auto;
	padding: 0;
	overflow: hidden;
	background: #fff;
	max-width: 100vh;
}
.term-container > * {
	flex: 1 1 auto;
	min-height: 0;
	min-width: 0;
}

.signature-container {
	width: 100%;
	max-width: 50em;
	margin: auto;
	padding: 0.75em;
}

.signature-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.pdf,
.pdf canvas {
	display: block !important;
	margin: 0 !important;
	padding: 0 !important;
	background: #fff !important;
}
</style>